export class ContratoUsuarioFormModel {
    constructor(
        public email: string = '',
        public apelido: string = '',
        public saudacao: string = '',
        public senha: string = '',
        public confirmar: string = ''
    ) { }
}